import {
  type Node,
  type Edge, MarkerType, Position,
} from "@xyflow/react";
import { getAssetStatus, getStatus } from "./statusMapper";
import { JobType } from "../types/statusTypes";
import { nodes, edges } from "./graphNodesAndEdges";

export function generateNodes(jobs: Record<string, JobType>): Node[] {
  const assetStatus = getAssetStatus(jobs);

  return nodes.filter((node) => {
    return Object.hasOwn(jobs, node.id);
  }).map(({ id, data, ...node }) => {
    return {
      ...node,
      id,
      data: {
        ...data,
        id,
        assetStatus,
        restartAllowed: jobs[id].restartAllowed,
      },
      selectable: true,
      focusable: false,
      draggable: false,
      connectable: false,
      deletable: false,
      sourcePosition: Position.Right,
      targetPosition: Position.Left,
      type: "output",
      className: getStatus(jobs[id].status),
    };
  });
}

export function generateEdges(): Edge[] {
  return edges.map(({ source, target }) => {
    return {
      className: "edge", type: "smoothstep",
      source: source,
      target: target,
      id: `e-${source}->${target}`,
      selectable: false,
      focusable: false,
      markerEnd: {
        color: "black",
        type: MarkerType.Arrow,
      },
    };
  });
}
